import { Component } from '@angular/core';

@Component({
	selector: 'link-blocked',
	template: require('./link-blocked.component.html'),
	host: { class: 'flex-column min-height-full-vh-bg-color' },
})
export class LinkBlockedComponent {}
